<template>
  <div>
    <router-view></router-view>
    <div class="copyright" v-if="false">
      <ul class="list-unstyled">
        <li>
          Developed by:
        </li>
        <li>John Villafania</li>
        <li><i>Front-end</i></li>
        <li>Jan Christian Aristain</li>
        <li><i>Back-end</i></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "LayoutLogin"
};
</script>
<style lang="scss">
.copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 15px;
}
</style>
